'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _colors = require('HubStyleTokens/colors');

var _Color = require('../core/Color');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isVertical = function isVertical(side) {
  return side === 'top' || side === 'bottom';
};

var UIOverhang = _styledComponents2.default.div.withConfig({
  displayName: 'UIOverhang'
})(['background-image:', ';background-size:', ';height:', ';width:', ';opacity:', ';pointer-events:none;position:absolute;top:', ';bottom:', ';left:', ';right:', ';'], function (_ref) {
  var gradientColor = _ref.gradientColor,
      side = _ref.side;
  return 'linear-gradient(to ' + side + ', ' + (0, _Color.rgba)(gradientColor, 0) + ', ' + gradientColor + ')';
}, function (_ref2) {
  var side = _ref2.side,
      size = _ref2.size;
  return isVertical(side) ? '100% ' + size + 'px}' : size + 'px 100%';
}, function (_ref3) {
  var side = _ref3.side,
      size = _ref3.size;
  return isVertical(side) && size + 'px';
}, function (_ref4) {
  var side = _ref4.side,
      size = _ref4.size;
  return !isVertical(side) && size + 'px';
}, function (_ref5) {
  var opacity = _ref5.opacity;
  return opacity;
}, function (_ref6) {
  var side = _ref6.side;
  return side !== 'bottom' && 0;
}, function (_ref7) {
  var side = _ref7.side;
  return side !== 'top' && 0;
}, function (_ref8) {
  var side = _ref8.side;
  return side !== 'right' && 0;
}, function (_ref9) {
  var side = _ref9.side;
  return side !== 'left' && 0;
});

UIOverhang.propTypes = {
  gradientColor: _propTypes2.default.string.isRequired,
  opacity: _propTypes2.default.number.isRequired,
  side: _propTypes2.default.oneOf(['top', 'bottom', 'left', 'right']).isRequired,
  size: _propTypes2.default.number.isRequired
};

UIOverhang.defaultProps = {
  gradientColor: _colors.KOALA,
  opacity: 1,
  size: 14
};

exports.default = UIOverhang;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/scroll/UIOverhang.js
// module id = 606
// module chunks = 177